import { Icon } from '@iconify/react/dist/iconify.js';
import { FormControl, FormHelperText, FormLabel, MenuItem, Select, Typography } from '@mui/material';
import * as React from 'react';


export default function CustomSelect({ values, variant, onChange, error, data, title, startAdornment, required, disabled, placeholder, subtitle, icon, name, valueName, labelName, width, height, marginTop = "0px", type, sx, ableClear = true, module, border }) {
    return (
        <>
            <FormControl variant={variant ? variant : "outlined"} fullWidth={width ? false : true} size="small">
                {title && <FormLabel style={{ fontFamily: 'SophiaPro', fontWeight: 500, paddingBottom: 4, fontSize: 14, margin: 0, color: "#594A4E" }}>{title}</FormLabel>}
                <Select
                    value={values}
                    name={name}
                    required={required}
                    disabled={disabled}
                    displayEmpty
                    sx={{
                        ...sx,
                        boxShadow: "none",
                        ".MuiOutlinedInput-notchedOutline": { border: 0 },
                        "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                        {
                            border: 0,
                        },
                        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            border: 0,
                        },
                    }}
                    startAdornment={startAdornment && <i className={`${startAdornment} p-2`}></i>}
                    disableUnderline={!variant || variant !== "standard"}
                    renderValue={values !== "" ? undefined : () => disabled ? "" : placeholder}
                    onChange={(e) => onChange(e.target.value)}
                    style={{
                        color: (values === "" || values == "-1") ? "#BDBDBD" : 'inherit',
                        width: width && width,
                        height: height ? height : "43px",
                        marginTop: marginTop,
                        borderRadius: 12,
                        borderBottom: error ? "1px solid #BA2727" : "1px solid #D9D9D9",
                        border: border || '1.5px solid #E6E6E6',
                        paddingInline: 10,
                        backgroundColor: disabled ? "#f1f3f4" : "white",
                        fontSize: 14
                    }}
                    inputProps={{ sx: { padding: 1 } }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                borderRadius: 10,
                                maxHeight: 250, // limit the height of the dropdown
                            },
                        },
                    }}
                    IconComponent={() => (
                        ableClear ? (values == '-1' || !values) ? <i className="ri-arrow-down-s-line" style={{ color: '#031634' }}></i> : <i className="ri-close-line font-size-18" style={{ color: '#D9D9D9', cursor: disabled ? 'default' : 'pointer' }} onClick={() => disabled ? '' : onChange('')} /> : <Icon style={{ color: '#D9D9D9', fontSize: "12px" }} icon={"fluent:chevron-down-12-filled"} />
                    )}
                >
                    <MenuItem style={{ display: "none" }} key={""} value="-1" disabled>{placeholder}</MenuItem>
                    <MenuItem style={{ display: "none" }} key={"all"} value="all" disabled>{placeholder}</MenuItem>
                    {
                        module &&
                        <MenuItem disabled value="">
                            {module}
                        </MenuItem>
                    }
                    {
                        data?.length > 0 ? data.map((x, idx) =>
                            <MenuItem key={idx}
                                value={x[`${valueName}`] || x.value || x.id}
                                style={{
                                    backgroundColor: (x[`${valueName}`] || x.value || x.id) === values ? '#F2F2F2' : 'white',
                                    color: (x[`${valueName}`] || x.value || x.id) === values ? '#031634' : '#031634'
                                }}
                            >
                                {
                                    icon ?
                                        <Typography><i className={`${x?.icon} p-2`}></i> {x[`${labelName}`] || x.label || x.name}</Typography>
                                        :
                                        (labelName && x[`${labelName}`]) || x.label || x.name
                                }
                            </MenuItem>
                        ) :
                            <MenuItem disabled>No options available</MenuItem>
                    }
                </Select>
                <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>
            </FormControl>
            {error && <FormHelperText className='d-flex align-items-center' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error || ""}</FormHelperText>}

        </>
    );
}
